import { useEffect, useState } from 'react'
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline'
import { useUser } from '../../contexts/UserContext'

const ThemeToggle = () => {
  const { updateThemePreference } = useUser()
  const [isDark, setIsDark] = useState(false)
  
  useEffect(() => {
    // Check current theme from document
    const checkDarkMode = () => {
      const isDarkMode = document.documentElement.classList.contains('dark')
      setIsDark(isDarkMode)
    }
    
    checkDarkMode()
    
    // Watch for changes to the dark class
    const observer = new MutationObserver(checkDarkMode)
    observer.observe(document.documentElement, { 
      attributes: true, 
      attributeFilter: ['class'] 
    })
    
    return () => observer.disconnect()
  }, [])
  
  const toggleTheme = async () => {
    const newTheme = isDark ? 'light' : 'dark'
    
    try {
      await updateThemePreference(newTheme)
      // The UserContext will apply the theme, which will trigger the observer
    } catch (err) {
      console.error('Failed to save theme preference:', err)
      // Apply theme locally if API call fails
      if (isDark) {
        document.documentElement.classList.remove('dark')
      } else {
        document.documentElement.classList.add('dark')
      }
      localStorage.setItem('theme', newTheme)
    }
  }
  
  return (
    <button
      onClick={toggleTheme}
      className="
        p-2 rounded-md
        text-muted-foreground
        hover:bg-accent
        transition-colors duration-150
      "
      aria-label="Toggle theme"
    >
      {isDark ? (
        <SunIcon className="w-5 h-5" />
      ) : (
        <MoonIcon className="w-5 h-5" />
      )}
    </button>
  )
}

export default ThemeToggle

